import baseMerge from "./component-library328.mjs";
import createAssigner from "./component-library329.mjs";
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
const merge$1 = merge;
export {
  merge$1 as default
};
